import {
  DrawerState,
  DrawerActionTypes,
  TOGGLE_DRAWER,
  SET_DRAWER_MODE,
  SET_MOBILE_STATE,
  SET_FORCE_HIDE_NAV,
} from './types'

// Initial state for the drawer
const initialState: DrawerState = {
  drawerActive: true, // Changed to true initially, like the old context-based implementation
  drawerCompact: false,
  displayMode: 'expanded',
  isMobile: false,
  forceHideNav: false,
}

export const reducer = (
  state = initialState,
  action: DrawerActionTypes
): DrawerState => {
  console.log(
    'DRAWER REDUCER: Processing action',
    action.type,
    'current state:',
    state
  )

  switch (action.type) {
    case TOGGLE_DRAWER:
      console.log(
        'DRAWER REDUCER: Toggling drawer from',
        state.drawerActive,
        'to',
        !state.drawerActive
      )
      return {
        ...state,
        drawerActive: !state.drawerActive,
      }

    case SET_DRAWER_MODE:
      const newMode = action.payload
      // Calculate drawerCompact based on mode
      const drawerCompact = newMode === 'compact'
      console.log(
        'DRAWER REDUCER: Setting mode to',
        newMode,
        'drawerCompact =',
        drawerCompact
      )

      return {
        ...state,
        displayMode: newMode,
        drawerCompact,
      }

    case SET_MOBILE_STATE:
      const isMobile = action.payload
      // When switching to mobile, also update drawerActive accordingly
      console.log(
        'DRAWER REDUCER: Setting mobile state to',
        isMobile,
        'drawerActive will be',
        isMobile ? false : !state.forceHideNav
      )

      return {
        ...state,
        isMobile,
        drawerActive: isMobile ? false : !state.forceHideNav,
      }

    case SET_FORCE_HIDE_NAV:
      console.log(
        'DRAWER REDUCER: Setting forceHideNav to',
        action.payload,
        'drawerActive will be',
        state.isMobile ? false : !action.payload
      )

      return {
        ...state,
        forceHideNav: action.payload,
        drawerActive: state.isMobile ? false : !action.payload,
      }

    default:
      return state
  }
}
